export default __webpack_public_path__ + "static/media/parkingrampe7.9cf4f42c.jpg";